import SubscriptionPauseModal from './SubscriptionPauseModal';

export default SubscriptionPauseModal;
